import { EdcTerminalDetailPage } from "@/features/edc-terminal/pages/EdcTerminalDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/edc-terminal/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["edc_terminals.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: EdcTerminalDetailPage,
});
